import { LanguageSelectionHelper } from "app/helpers/languageSelectionHelper";
import isEmpty from "lodash/isEmpty";
import { urls } from "../api/urls";
import { api, getDataSimple } from "../helpers/apiHelperV3";
import { SessionHelper } from "../helpers/sessionHelper";

const API_SESSION = urls.accounts.API_SECURITY_SESSION();

/**
 * fetch account information
 * account information include a finance field
 */
export const fetchSession = (): any => {
  const url = API_SESSION;
  return getDataSimple(url);
};
export const expireSession = (): any => {
  const url = API_SESSION;
  const params = {
    reason: "expired",
  };
  return api
    .delete(url, {
      params: params,
    })
    .then(resp => {
      return resp.data;
    })
    .catch(error => {
      throw error;
    });
};
export const loginUser = (
  username: string,
  password: string,
  totpCode: string
): any => {
  const url = API_SESSION;
  const data = {
    username,
    password,
    totpCode,
  };
  return api
    .post(url, data)
    .then(resp => {
      return resp.data;
    })
    .catch(error => {
      if (!isEmpty(error)) {
        if (!isEmpty(error.response)) {
          if (!isEmpty(error.response.data)) {
            throw error.response.data.errors[0];
          }
        }
      } else throw error;
    });
};

/* persist selected session view to API */
export const updateSessionView = (
  payload: string,
  session: Record<string, any>
): any => {
  const url = API_SESSION;
  const data = {
    uiViewMode: payload,
    username: session.username,
  };
  return api
    .post(url, data)
    .then(resp => {
      return resp.data;
    })
    .catch(error => {
      throw error;
    });
};

/*  logout session/user  */
export const logout = () => {
  const url = API_SESSION;
  //
  api
    .delete(url)
    .then(resp => {
      SessionHelper.clearToken();
      LanguageSelectionHelper.clearLanguageChanged();
    })
    .then(resp => {
      const url = window.location.host;
      window.location.replace(`https://${url}`);
    })
    .catch(error => {
      console.error(error);
    });
};
